import { styled } from '@styledComponents';
import { Text } from '@components/typography';
import { themeSpace } from '@utils/styledTheme.util';
import { Flex } from '@components/Flex';

export const StyledTagText = styled(Text)`
  font-size: 13px;
  font-weight: 700;
`;

export const StyledTag = styled(Flex)`
  align-items: center;
  background-color: #189289; // custom color used for new flag
  border-radius: ${themeSpace(6)};
`;
